import { connect } from 'react-redux';

import VideoScreen from './VideoScreen';

const mapStateToProps = () => ({});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(VideoScreen);
